import React from "react";
import { User, UserCredential } from "../../Model/User";
import "./UserProfile.css";

// get it from https://stackoverflow.com/a/3426956/8637775
function stringToColor(str: string) {
  let hash = 0;
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = (hash & 0x00ffffff).toString(16).toUpperCase();

  return "#" + "00000".substring(0, 6 - color.length) + color;
}

function getForeGroundColor(hex: string) {
  if (hex.indexOf("#") === 0) {
    hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    throw new Error("Invalid HEX color.");
  }
  let r = parseInt(hex.slice(0, 2), 16);
  let g = parseInt(hex.slice(2, 4), 16);
  let b = parseInt(hex.slice(4, 6), 16);

  // http://stackoverflow.com/a/3943023/112731
  return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
}

type Props = {
  user: User;
  style?: React.CSSProperties;
};

const UserProfile = ({ user, style }: Props) => {
  const userName =
    user.name !== null && user.name !== undefined && user.name !== ""
      ? user.name
      : user.userName
      ? user.userName
      : "User";
  const backgroundColor = stringToColor(userName);
  const foregroundColor = getForeGroundColor(backgroundColor);
  const userInitial = userName.charAt(0).toUpperCase();
  return (
    <div
      style={{
        backgroundColor: backgroundColor,
        color: foregroundColor,
        ...style,
      }}
      className="user-profile"
    >
      {userInitial}
    </div>
  );
};

export default UserProfile;
